import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6d00c214&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=6d00c214&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlocksCoursePageHeader: require('/opt/build/repo/components/Blocks/CoursePageHeader.vue').default,CardsAccreditation: require('/opt/build/repo/components/Cards/Accreditation.vue').default,CoursesWhy: require('/opt/build/repo/components/Courses/Why.vue').default,CardsCourseCardsOnline: require('/opt/build/repo/components/Cards/CourseCardsOnline.vue').default,UIAudioBanner: require('/opt/build/repo/components/UI/AudioBanner.vue').default,CardsCourseCardsCombined: require('/opt/build/repo/components/Cards/CourseCardsCombined.vue').default,CardsCourseCardsDiploma: require('/opt/build/repo/components/Cards/CourseCardsDiploma.vue').default,BlocksTextBanner: require('/opt/build/repo/components/Blocks/TextBanner.vue').default,CardsCourseCardsAdvanced: require('/opt/build/repo/components/Cards/CourseCardsAdvanced.vue').default,CardsCourseCardsClassroom: require('/opt/build/repo/components/Cards/CourseCardsClassroom.vue').default,BlocksFaq: require('/opt/build/repo/components/Blocks/Faq.vue').default,CoursesFAQ: require('/opt/build/repo/components/Courses/FAQ.vue').default})
